import enLocale from 'element-ui/lib/locale/lang/en'
export default {
    allTitle: {
        moreBtn: 'Read More...',
        outBtn: 'Logout',
        accountBtn: 'account management',
        switchBtn: 'Switch factory'
    },
    leftNav: {
        navfoot: 'Powered by www.tst-cloud.com',
        navTitle: 'TST-IIOT Cloud',
        ptnavTitle: 'ZcrubberEquiepmentIOT',
        navOne: 'Home',
        navTwo: 'Factory',
        navThree: 'EquipmentDashBoard',
        navFour: 'EquipmentStepAnalysis',
        navFive: 'RunningRecord',
        navSix: 'ShiftRecord',
        navSeven: 'FaultAlarm',
        navSeven1: 'EquipmentFaultAlarm',
        navSeven2: 'PartsFaultAlarm',
        navEight: 'Favorite',
        navNine: 'EventGantt',
        navTen: 'ProductionAnalysis',
        navEleven: 'SingleTireStepAnalysis',
        navTwelve: 'CycleDistribution',
        navThirteen: 'ReloadingStatistics',
        navFourteen: 'AnalogValueAnalysis',
        navfiveteen: 'SingleEquipmentReloadingAnalysis',
        navSixteenth: 'Productivity Forecast',
        navSeventeenth: 'Lab',
        navSeventeenth1: 'CycleDistribution',
        navSeventeenth2: 'ReloadingStatistics',
        navSeventeenth3: 'ReloadingAnalysis',
        navSeventeenth4: 'DetailedStepReport',
        navSeventeenth5: 'ProductivityForecast',
        navSeventeenth6: 'AnalogValueAnalysis',
        navEighteenth: 'Equipment Step Statistics Report',
        navnineteen: 'WorkShopDashBoard',
        navtwentieth: 'EquipmentTimeSharingInformation',
        navTwentyOne: 'AnalogChartQuickView',
        navTwentyTwo: 'EquipmentUtilizationRate',
        navTwentyThree: 'EquipmentDetailedStepReport ',
        navTwentyFour: 'Tool',
        navTwentyFive: 'EquipmentEfficiency',
        navTwentySix: 'ProcessVariableComparison',
        navTwentySeven: 'ProcessVariableLogging',
        navTwentyEight: 'OffsetVariableLogging',
        navTwentyNine:'DeviationRectifyingData',
        nav20: '3dModel',
        platform: 'Platform',
        nav21: 'Self-help DashBoard',
        nav22: 'Semi-productQuality',
        nav23: 'account management',
        nav24: 'EventGantt V2',
        nav25: 'EquipmentIntegratedInformation',
        nav26: 'DailyProductionAnalysis',
        nav27: 'WeeklyProductionAnalysis',
        nav28: 'MonthlyProductionAnalysis',
        nav29: 'Semi-productQualityReport',
        nav30: 'WorkShopAlarmStatistics',
        nav31: 'SpecificationInformation',
        nav32: 'TireInformation',
        nav33: 'WorkShopFaultsStatistics',
        nav34: 'Semi-productQualityTrack',
        nav35: 'AnalogDataMonitoring',
        nav36: 'EquipmentEfficiency',
        nav37: 'VariableManagement',
        nav38: 'AnalogQuantity',
        nav39: 'GiantEmbryoMachineDigitalTwin',
        navVpn: 'VPNBox',
        navVpnApply: 'VPNApply',
        navVpnRewiew: 'VPNRewiew',
        navVpnAdd: 'VPNManage',
        navVpnInstructions: 'DownloadInstruction',
        navVpnSoft: 'SoftwareDownload',
    },
    // 页面 title
    pageTitle:{
        TireStep1:'SingleTireStepAnalysis V1',
        TireStep2:'SingleTireStepAnalysis V2'
    },
    // EventRecord 错误信息查询
    EventRecord: {
        topTitle: 'FaultAlarmQuery',
        condition1: 'Equipment:',
        condition2: 'EventCode：',
        condition3: 'Type：',
        condition4: 'Group：',
        condition5: 'EM：',
        condition6: 'Duration：',
        selectPlacehoder: 'select',
        timeStart: 'startTime',
        timeEnd: 'endTime',
        Clean: 'Clean',
        Search: 'Search',
        Export: 'Export',
        tableTitle1: 'Machine',
        tableTitle2: 'EventCode',
        tableTitle3: 'Event',
        tableTitle4: 'Group',
        tableTitle5: 'EM',
        tableTitle6: 'Type',
        tableTitle7: 'StartTime',
        tableTitle9: 'EndTime',
        tableTitle8: 'Duration',
        monthTableTitle1:   'Total production',
            monthTableTitle2:   'Reloading total time',
            monthTableTitle3:   'Best production',
            monthTableTitle4:   'Worst production',
        topTips: 'Event Record, real-time recording  all event of monitoring equipment. Including alarm, error, exception, shutdown, failure and other information. You can filter data by time, machine, factory, workshop, etc.',
        pickTime1: 'last 4 hours',
        pickTime2: 'last 8 hours',
        chartTitle: 'Top 3 Fault',
        chartTitle2: 'Top 3 Alarm',
        machinesError: 'has no FaultAlarm information for nearly 7 days.',
        selectTimeError: 'Please choose the date'
    },
    // home首页
    home: {
        listTitle: 'Machines',
        seachPlacehoder: 'Search...',
        All: 'All',
        online: 'online',
        offline: 'offline',
        notConnected: 'Not yet connected',
        event: 'Event'
    },
    // MachineDashBoard
    MachineDashBoard: {
        cascaderPlaceHoder: 'switch',
        infoTitle1: 'Machine status:',
        infoTitle2: 'Current Dimension:',
        infoTitle3: 'Current Shift',
        infoTitle4: 'Continuous Running:',
        infoTitle5: 'Current Productivity:',
        infoTitle6: 'Current Recipe',
        infoTitle7: 'Simultaneous Maximum Output',
        stateDescribe1: 'Current Cycle time',
        stateDescribe2: 'Standard Cycle',
        stateDescribe3: 'Average Cycle time',
        stateDescribe4: 'Best Cycle time',
        stateDescribe5: 'Shift Plan',
        stateDescribe6: 'Estimate Productivity',
        stateDescribe7: 'Current Shift Productivity',
        stateDescribe8: 'Simultaneous Maximum Output',
        class5: 'circle',
        class1: 'tires',
        class2: 'tires/shift',
        class3: 'shift',
        class4: 'set',
        maskOffline: 'This machine is offline',
        maskNotConnected: 'This machine is Not Connected',
        maskNoproduction: 'This machine is Stop Producing',
        allMachine: 'All Machine',
        networked: 'Networked',
        state1: 'Running',
        state2: 'Stand by',
        state3: 'Fault',
        state4: 'Stop',
        state5: 'Offline',
        state6: 'Not yet connected',
        labelTitle: 'Equipment:',
        title1: 'Latest Fault Alarm',
        title2: 'Equipment Daily Report',
        title3: 'MonthlyProduction',
        //各工位循环周期时间样式 新增
        cycletime: 'Cycle Time of Station',
        station: 'Station',
        current: 'Current',
        last:'Last',
        best: 'Best',
        average: 'Average',
        output: 'Output',
        CC: 'CC',
        BT: 'BT',
        SP: 'SP',
        more: 'More',
        StartTime: 'StartTime',
        EndTime: 'EndTime',
        class6: 'Cycle Time',
        pickTime1: 'last 1 hour',
        pickTime2: 'last 3 hours',
        pickTime3: 'last 8 hours',
        pickTime4: 'last 1 day',
        pickTime5: 'last 2 days',
        pickTime6: 'last 30 minutes',
        //日期选择器手动输入的时间超过七天的提示语
        TimeMore7: 'The selected date range cannot exceed 7 days',
        noTimeList:'No Equipment Daily Report'
    },
    // login
    login: {
        title1: 'Password',
        title2: 'Login with verification code',
        placehoder1: 'Phone Number',
        placehoder2: 'Password',
        placehoder3: 'verification code',
        placehoder4: 'New password',
        placehoder5: 'Repeat your password',
        placehoder6: 'account',
        topTitleLeft: 'TST',
        topTitleRight: '-IIOT Cloud',
        pttopTitleLeft: 'Zcrubber',
        pttopTitleRight: 'EquiepmentIOT',
        login: 'Login',
        error1: 'Please enter your mobile phone number',
        error2: 'Please enter the password',
        error3: 'Please confirm your mobile phone number',
        error4: 'Password length should be 6 ~ 12 characters',
        error5: 'Please enter the verification code',
        error6: 'Please enter your password again',
        error7: 'Two inconsistent passwords',
        error8: 'Please enter the account number',
        wechatTitle: 'Login with WeChat QRCode',
        getMsg: 'Get SMS',
        RsetMsg: 'Reset your password',
        next: 'Next',
        okBtn: 'OK and Login',
        forgetPwd: 'forget password',
        remember: 'Automatic login within 15 days',
        or: "OR",
        wxTitle: "Login with WeChat QRCode",
        EnterpriseWxTitle: 'Login with Enterprise WeChat QRCode',
        dingTitle: 'Login with DingTalk QRCode',
        bindtitle1: 'WeChat bind TST-IIOT account',
        bindtitle2: 'Enterprise WeChat bind TST-IIOT account',
        bindtitle3: 'Login with DingTalk QRCode',
        bindTips: 'Your account is not registered, Please contact us to make an appointment.',
        contactBtn: '»Contact us',
        wxTips: 'Login and follow Official account with WeChat QR code',
        selectfactory: 'Please select the Factory',
        scanbtn:'Login with wechat scan code',
        scanbtn2:'Login with dingding scan code'
    },
    // 大屏监控
    platform: {
        equipment: 'Equipment',
        running: 'Running',
        fault: 'Fault',
        tooling: 'lack materials',
        Reloading: 'Reloading Statistics and Prediction',
        TotalTime: 'Reloading Total Time: (Last 3 hours)',
        title: 'STEEL RADIAL TIRE SHOP',
        Events: 'Latest Events',
        Output: 'Output Statistics and Prediction',
        TotalOutput: 'Total Output Statistics and Prediction',
        EquipmentOutput: 'Equipment Output Statistics (Last 3 hours)',
        Average: 'Average Cycle time： (Last 3 hours)',
        TotalTimes: 'Total Time'
    },
    // 甘特图
    gantt: {
        placehoder1: 'select',
        placehoder2: 'Search',
        labelTitle: 'Equipment:',
        showBtn: 'show',
        StartTime: 'StartTime',
        EndTime: 'EndTime',
        dialogTitle: 'Select data for the chart',
        dialogCancel: 'Cancel',
        dialogOk: 'Ok',
        exportBtn: 'Export',
        dialogListTitle1: 'All',
        dialogListTitle2: 'Gantt',
        error1: 'Please select the Machine',
        error2: 'Please choose the date',
        error3: 'Most choice 64 data',
        error4: 'Please select the data',
        label1: 'EventCode',
        label2: 'Part',
        label3: 'Step',
        label4: 'Description',
        label5: 'StartTime',
        label6: 'EndTime',
        label7: 'Duration',
        pickTime1: 'last 1 hour',
        pickTime2: 'last 3 hours',
        pickTime3: 'last 8 hours',
        pickTime4: 'last 1 day',
        pickTime5: 'last 2 days',
        error: 'No Data',
        error5: 'Please select the Step',
        selectStep: 'Step'
    },
    // 甘特图V2
    ganttv2:{
        collapse:'Collapse all',
        expand:'expand all'
    },
    // 产量记录
    Production: {
        placehoder1: 'select',
        labelTitle: 'Equipment:',
        showBtn: 'show',
        StartTime: 'StartTime',
        EndTime: 'EndTime',
        radio1: 'Last 2 shifts',
        radio2: 'Last 3 shifts',
        radio3: 'Select Time',
        placehoderLabel: 'GreenTireCount',
        error1: 'Please select the Machine',
        error2: 'Please choose the date',
        dialogTitle: 'Chart configuration',
        dialogTitle2: 'X-axis',
        dialogLabel1: 'Data interval:',
        dialogLabel2: 'Start time:',
        dialogCancel: 'Cancel',
        dialogOk: 'Ok',
        hourTitle: ' hour',
        hoursTitle: ' hours',
        shiftTitle: ' shift',
        Ylabel: 'Production',
        Ylabel2: 'Cycle Time',
        tips: 'Production time'
    },
    // 步序时间图标
    StepCycleTime: {
        placehoder1: 'select',
        labelTitle1: 'Equipment:',
        placehoder2: 'All',
        labelTitle2: 'Step:',
        showBtn: 'show',
        StartTime: 'StartTime',
        EndTime: 'EndTime',
        error1: 'Please select the Machine',
        error2: 'Please choose the date',
        error3: 'Please select the Step',
        pickTime1: 'yd ',
        pickTime2: 'td ',
        shiftTitle: 'Shift',
        tableLeftTitle: 'Number of times',
        tableRightTitle: 'Cumulative growth rate',
        pickLable1: 'yesterday 1st shift',
        pickLable2: 'yesterday 2nd shift',
        pickLable3: 'yesterday 3rd shift',
        pickLable4: 'today 1st shift',
        pickLable5: 'today 2nd shift',
        pickLable6: 'today 3rd shift',
        tableTitle: 'Chart configuration',
        tableLable1: 'Shift output Information ',
        tableLable2: 'Shift output Chart Display Limits: ',
        error4: 'please enter number',
        error5: 'please enter integer',
        error6: 'please enter Upper limit',
        error7: 'please enter lower limit',
        dialogCancel: 'Cancel',
        dialogOk: 'Ok',
        dialogTitle1: 'Output in time range:',
        dialogTitle2: 'Full shift output:',
        dialogTitle3: ' tires',
        error8:'No more than 7 days'
    },
    // 单个台步序时间（双甘特图）
    SingleTireStepAnalysis: {
        placehoder1: 'select',
        labelTitle: 'Equipment:',
        showBtn: 'Seach',
        StartTime: 'StartTime',
        EndTime: 'EndTime',
        pickTime1: 'Last 2 shifts',
        pickTime2: 'Last 3 shifts',
        title: 'PartsFault'
    },
    // 节拍时间分布
    CycleDistribution: {
        error1: 'Query failure!',
        tableTitle1: 'StartTime',
        tableTitle2: 'EndTime',
        tableTitle3: 'Total',
        tableTitle4: 'Check Cacul',
        tabtitle: 'Day',
        tabtitle2: 'Shift'
    },
    // 换料统计
    ReloadingStatistics: {
        tableTitle1: 'EventCode',
        tableTitle2: 'Event',
        tableTitle3: 'Unit',
        innerTitle1: 'Detail',
        innerTitle2: 'EndTime',
        innerTitle3: 'Tire Number of the Day',
        innerTitle4: 'StartTime',
        innerTitle5: 'Duration',
        innerTitle6: 'Output',
        innerTitle7: 'Cutting',
        frequency: '',
        minute: 'm',
        second: 's',
        tires: 'tires',
        Total: 'Total',
        export: 'Export'
    },
    //单胎步序分析
    AnalogValueAnalysis: {
        EventCode: 'EventCode',
        Choosedate: 'Date',
        Choosetime: 'Time',
        show: 'Show',
        equipment: 'Please choose an Equipment first',
        selectEventCode: 'Please choose an Event Code',
        pChoosedate: 'Please choose the Date',
        pChoosetime: 'Please choose the Time'
    },
    // 单机供料报表
    er02: {
        title1: 'Machine',
        title2: 'Prod',
        title3: 'Total',
        Frequency: 'Frequency',
        Occurred: 'Occurred',
        LostTime: 'Lost time'
    },
    PF001: {
        ProductivityForecast: 'Productivity Forecast',
        actual: 'actual value',
        predicted: 'predicted value',
        noData: 'no data!',
        show: 'Show',
        hours: 'hours',
        productivity: 'productivity'
    },
    DetailedStepReport: {
        weeklyReport: 'Weekly Report',
        StepStatisticsReport: 'StepStatisticsReport',
        NoData: 'No Data'
    },
    // 车间详情信息
    WorkShopDashBoard: {
        label1: 'WorkShop:',
        dlTitle: 'Equipments Step Info Report',
        dlTitle2: 'Reloading Statistics Report',
        title3: 'Productivity Report',
        exportBtn: 'Export',
        monthlabel: 'Previous Month / Next Month',
        tabletitles1: 'Equipment',
        listLabel1: 'cycleTime:',
        listLabel2: 'shiftproductivity:',
        listLabel3: 'shift',
        machineLifeCycle1: 'Manufacturing',
        machineLifeCycle2: 'Ex-factory Debugging',
        machineLifeCycle3: 'Installation and Debugging',
        machineLifeCycle4: 'Operation',
        machineLifeCycle5: 'Maintenance and repair',
        machineLifeCycle6: 'Technological transformation',
        machineLifeCycle7: 'Scrap',
        faultAlarmStatisticsReport: 'Fault Statistics Report',
        weeklabel: 'Previous Week / Next Week',
        format: 'Week WW',
        event: 'Event',
        total: 'total',
        noEquipmentData: 'No Data',
        noEquipmentTableMessage:'Data not available for viewing',
        noEquipmentInFactory:'Equipments not available for viewing',
        tooltipTitle1:'EquipmentCode',
        tooltipTitle2:'CommunicationCode',
        tooltipTitle3:'ProductionCode',
        tooltipTitle4:'LifeCycle',
        machineLifeList1:'Manufacturing',
        machineLifeList2:'Ex-factoryTesting',
        machineLifeList3:'ErectionTesting',
        machineLifeList4:'Using',
        machineLifeList5:'Maintenance', 
        machineLifeList6:'TechnicalReconstruction', 
        machineLifeList7:'Write-off'
    },
    //部件故障报警查询
    PartsFaultAlarm: {
        part: 'Part',
        show: 'Show',
        Faults: 'Faults',
        Alarms: 'Alarms',
        Resets: 'Resets',
        eventCode: 'EventCode',
        Action: 'Action',
        EndState: 'End State',
        tableTitle1: 'Date/Time',
        tableTitle2: 'Type',
        tableTitle3: 'Code/Description',
        tableTitle4: 'Machine',
        tableTitle5: 'Servo Axis',
        tableTitle6: 'Except Code/Description',
        search: 'Search',
        all: 'All',
        enterText: 'Enter text',
        StartTime: 'StartTime',
        EndTime: 'EndTime',
        except: 'Except',
        radio1: 'yesterday',
        radio2: 'Previous Week',
    },
    //故障时间统计
    FailureTimeStatistics: {
        date: 'Date',
        StartTime: 'StartTime',
        EndTime: 'EndTime',
        Production: 'Production',
        FaultTimes: 'Fault times',
        FailureTotalTime: 'Failure total time',
        FailureEffectiveTime: 'Failure effective time',
        factory: 'Factory:'
    },
    //
    AnalogChartQuickView: {
        DashBoard: 'DashBoard：',
        Choosedate: 'Date',
        Choosetime: 'Time',
    },
    //设备稼动率
    EquipmentUtilizationRate: {
        EURtitle: 'EquipmentUtilizationRate',
        SelectExportData: 'Select export data',
        ShiftInformation: 'Shift Information',
        ShiftProduction: 'Shift Production',
        TimeLossDueToFailure: 'Time loss due to failure(minutes)',
        TimeLossDueToReloading: 'Time loss due to reloading(minutes)',
        Production: 'Production',
        FailureEffectiveTime: 'Failure effective time',
        TimeOfReloading: 'Time of reloading (minutes)',
        righttitle: 'WorkShop'
    },
    //设备详细步序报告
    EquipmentDetailedStepReport: {
        EDStitle: 'Equipment Detailed Step Report',
    },
    //表单设计器
    fm: {
        formName: 'FormMaking',
        components: {
            fields: {
                input: 'Input',
                textarea: 'Textarea',
                number: 'Number',
                radio: 'Radio',
                checkbox: 'Checkbox',
                time: 'Time',
                date: 'Date',
                rate: 'Rate',
                color: 'Color',
                select: 'Select',
                switch: 'Switch',
                slider: 'Slider',
                text: 'Text',
                blank: 'Custom',
                fileupload: 'File',
                imgupload: 'Image',
                editor: 'Editor',
                cascader: 'Cascader',
                table: 'Sub-table',
                grid: 'Grid',
                tabs: 'Tabs',
                divider: 'Divider'
            },
            basic: {
                title: 'Basic Component',
            },
            advance: {
                title: 'Advance Component',
            },
            layout: {
                title: 'Layout',
            }
        },
        description: {
            containerEmpty: 'You can drag and drop the item from the left to add components',
            configEmpty: 'Please add a component',
            tableEmpty: 'You can drag and drop the item from the left to add components',
            uploadJsonInfo: 'There is the format of JSON below，you can overwrite it with you own JSON code'
        },
        message: {
            copySuccess: 'Copy Successed',
            validError: 'Form data validation failed'
        },
        actions: {
            import: 'Import JSON',
            clear: 'Clear',
            preview: 'Submit',
            json: 'Generate JSON',
            code: 'Generate Code',
            getData: 'Get Data',
            reset: 'Reset',
            copyData: 'Copy Data',
            cancel: 'Cancel',
            confirm: 'Confirm',
            addOption: 'Add Option',
            addColumn: 'Add Column',
            addTab: 'Add Tab',
            upload: 'Upload',
            add: 'Add'
        },
        config: {
            form: {
                title: 'Form Attribute',
                labelPosition: {
                    title: 'Label Position',
                    left: 'Left',
                    right: 'Right',
                    top: 'Top'
                },
                labelWidth: 'Label Width',
                size: 'Size',
                customClass: 'Custom Class'
            },
            widget: {
                title: 'Component Attribute',
                model: 'ID',
                name: 'Name',
                width: 'Width',
                height: 'Height',
                size: 'Size',
                labelWidth: 'Label Width',
                custom: 'Custom',
                placeholder: 'Placeholder',
                layout: 'Layout',
                block: 'Block',
                inline: 'Inline',
                contentPosition: 'Content Position',
                left: 'Left',
                right: 'Right',
                center: 'Center',
                showInput: 'Display Input Box',
                min: 'Minimum',
                max: 'Maximum',
                step: 'Step',
                multiple: 'Multiple',
                filterable: 'Searchable',
                allowHalf: 'Allow Half',
                showAlpha: 'Support transparency options',
                showLabel: 'Show lable',
                option: 'Option',
                staticData: 'Static Data',
                remoteData: 'Remote Date',
                remoteFunc: 'Remote Function',
                value: 'Value',
                label: 'Label',
                childrenOption: 'Sub-Option',
                defaultValue: 'Default Value',
                showType: 'Display type',
                isRange: 'Range Time',
                isTimestamp: 'Get time stamp',
                startPlaceholder: 'Placeholder of start time',
                endPlaceholder: 'Placeholder of end time',
                format: 'Format',
                limit: 'Maximum Upload Count',
                isQiniu: 'Upload with Qiniu Cloud',
                tokenFunc: 'A funchtin to get Qiniu Uptoken',
                imageAction: 'Picture upload address',
                tip: 'Text Prompt',
                action: 'Upload Address',
                defaultType: 'Data Type',
                string: 'String',
                object: 'Object',
                array: 'Array',
                number: 'Number',
                boolean: 'Boolean',
                integer: 'Integer',
                float: 'Float',
                url: 'URL',
                email: 'E-mail',
                hex: 'Hexadecimal',
                gutter: 'Grid Spacing',
                columnOption: 'Column Configuration',
                span: 'Grid spans',
                justify: 'Horizontal Arrangement',
                justifyStart: 'Start',
                justifyEnd: 'End',
                justifyCenter: 'Center',
                justifySpaceAround: 'Space Around',
                justifySpaceBetween: 'Space Between',
                align: 'Vertical Arrangement',
                alignTop: 'Top',
                alignMiddle: 'Middle',
                alignBottom: 'Bottom',
                type: 'Type',
                default: 'Default',
                card: 'Tabs',
                borderCard: 'Border-Card',
                tabPosition: 'Tab Position',
                top: 'Tob',
                // left: 'Left',
                // right: 'Right',
                bottom: 'Bottom',
                tabOption: 'Label Configuration',
                tabName: 'Tab Name',
                customClass: 'Custom Class',
                attribute: 'Attribute Action',
                dataBind: 'Data Binding',
                hidden: 'Hidden',
                readonly: 'Read Only',
                disabled: 'Disabled',
                editable: 'Text box is editable',
                clearable: 'Display Clear Button',
                arrowControl: 'Use the arrow for time selection',
                isDelete: 'Deletable',
                isEdit: 'Editable',
                showPassword: 'Display Password',
                validate: 'Validation',
                required: 'Required',
                patternPlaceholder: 'Fill in the regular expressions',
                newOption: 'New Option',
                tab: 'Tab',
                validatorRequired: 'Required',
                validatorType: 'Invaild format',
                validatorPattern: 'Unmatched pattern'
            }
        },
        upload: {
            preview: 'preview',
            edit: 'replace',
            delete: 'delete'
        }
    },
    // 半成品质量页面
    PQ: {
        tabPane1: 'Tread',
        tabPane2: '0# belt ply',
        tabPane3: '1# belt ply',
        tabPane4: '2# belt ply',
        tabPane5: '3# belt ply',
        tabPane6: '4# belt ply',
        tabPane7: 'L_SChafer',
        tabPane8: 'R_SChafer',
        tabPane9: 'BP',
        tabPane10: 'SW',
        tabPane11: 'IL',
        tabPane12: 'Cushion',
        treadInfo: {
            info1: 'Total：',
            info2: 'Qualified：',
            info3: 'Qualified rate：',
            info4: 'Rejected：',
            info5: 'Rejection rate：',
            info6: 'below lower tolerance：',
            info7: 'below lower tolerance rate：',
            info8: 'Above upper tolerance：',
            info9: 'Above upper tolerance rate：'
        },
        Export: 'Export',
        treadTableTitle: {
            title1: 'Date / Time',
            title2: 'Length(mm)',
            title3: 'GeShanChe Code',
            title4: 'Qualified（',
            title5: '<Standard deviation - lower tolerance',
            title6: '>Standard deviation + upper tolerance'
        },
        choseBtn: 'Select GeShanChe',
        placeholder: 'Select Date',
        yesterday: 'yesterday',
        threeDays: 'Last three days'
    },
    account: {
        topTitle: 'Account information',
        bottomTitle: 'Account security',
        infoLabels: {
            label1: 'Name：',
            label2: 'Profile photo：',
            label3: 'Job title：',
            label4: 'Company：',
            label5: 'Phone number：',
            label6: 'Email：',
            label7: 'WeChat：',
            label8: 'Enterprise WeChat：',
            label9: 'DingTalk：'
        },
        editBtn: 'Edit',
        saveBtn: 'save',
        changeBtn: 'Change',
        bindBtn: 'Bind',
        unbindBtn: 'Unbind',
        phoneTitle: 'Change phone number',
        placehode1: 'New phone number',
        placehode2: 'verification code',
        placehode3: 'Email address',
        getBtn: 'Get Msg',
        error1: 'Please enter your mobile phone number',
        error2: 'Please enter the verification code',
        error3: 'Please enter your Email address',
        error4: 'Please enter the correct email',
        verBtn: 'verification',
        bindTitle: 'Bind Email address',
        unbindTitle: 'Unbind Email',
        bindTitle2: 'Bind WeChat',
        unbindTitle2: 'Unbind WeChat',
        bindTitle3: 'Enterprise WeChat QRCode',
        unbindTitle3: 'Unbind Enterprise WeChat',
        bindTitle4: 'DingTalk QRCode',
        unbindTitle4: 'Unbind  DingTalk',
        unbindStrong: 'Unbind Email , You will:',
        unbindStrong2: 'Unbind WeChat , You will:',
        unbindStrong3: 'Unbind Enterprise WeChat , You will:',
        unbindStrong4: 'Unbind  DingTalk , You will:',
        unbindtips: 'Failure to receive timely notice',
        unbindtips2: "Can't login with WeChat",
        unbindtips3: "Can't login with Enterprise WeChat",
        unbindtips4: "Can't login with Enterprise  DingTalk",
        cofBtn: 'Confirm',
        error: 'Can not be empty',
        bindSuc: 'Binding succeeded'
    },
    ganttV2: {
        factory: 'factory',
        workshop: 'workshop',
        machine: 'machine',
        timeType1: '30Min',
        timeType2: '1Hour',
        downloadTitle: 'ExportButton',
        downloadBtn1: 'downloadJPEG',
        downloadBtn2: 'downloadPDF',
        downloadBtn3: 'downloadPNG',
        downloadBtn4: 'downloadSVG',
        marketPublicTitle: 'Tire Building workshop'
    },
    // 设备参数日报
    Dailyequipment: {
        placehoder1: 'select',
        labelTitle1: 'Equipment:',
        tabPane1: 'Secondary length measurement(banding side)',
        tabPane2: 'Tread rolling',
        tabPane3: '1 Band width',
        tabPane4: '2 Band width',
        tabPane5: '3 Band width',
        placehoder2: 'Select month',
        placehoder3: 'download',
        noEquipmentData:'No equipment to choose at present',
        nodata: 'Initialize an exception. Please try again',
        placehoder4: 'noData',
        changenodata: 'There are no Numbers of data that you have chosen',
        tabData: 'There is no data for today, you can try to view the data before yesterday',
        download: 'download'
    },
    // 车间报警统计
    WorkSHopAlarmStatistics: {
        placehoder1: 'select',
        labelTitle1: 'Equipment:',
        name: 'WorkSHopAlarmStatistics',
        weeklabel: 'Previous Week / Next Week',
        format: 'Week WW',
        event: 'Event',
        total: 'total',
        exportBtn: 'Export',
    },
    // 设备规格信息
    EquipmentSpecificationInformation: {
        name: 'Specification information',
        exportBtn: 'Export',
        format: 'Week WW',
        weeklabel: 'Previous Week / Next Week',
        marketPublicTitle: 'Tire Building workshop',
        factory: 'factory',
        label1: 'WorkShop:',
        cascaderPlaceHoder: 'switch',
        label2: 'Date',
        label3: 'Time',
        label4: 'Shift',
    },
    // 车间故障统计
      WorkShopFaultsStatistics: {
        title: 'WorkShopFaultsStatistics'
    },
    // 只针对于中策橡胶厂的底部文字
    ZcrubberEquiepmentIOT: {
        title: '由赛象云工业互联网提供技术支持'
    },
    // 班组名称
    shiftName:{
        Morning:'Morning ',
        Middle:'Middle ',
        Evening:'Evening ',
        A:'A',
        B:'B',
        C:'C',
        D:'D'
    },
    //新增设备平均效率对比
    EquipmentEfficiency:{
        chooseEquipment:'Equipment',
        chooseRecipe:'Recipe',
        error1:'Please choose the date',
        error2:'Please select the Machine',
        error3:'No data',
        error4:'Unrecord Recipe',
        error5:'No Machine',
        error6:'No Reviser',
        tableTitle1:'Machine',
        tableTitle2:'Station',
        tableTitle3:'CC',
        tableTitle4:'BT',
        tableTitle5:'SP',
        tableTitle6:'Equipment',
        tableTitle7:'Operator',
        tableTitle8:'Rolling',
        tableTitle9:'Recipe',
        button1:'OK',
        chooseReviser:'Reviser',
        chooseItem:'Item'
    },
    //新增工艺参数对比
    CompareCraft:{
        chooseRecipe:'Recipe',
        changePeople:'Reviser',
        changeTime:'Date/Time'
    },
    //新增工艺参数记录
    RecordCraft:{
        tableTitle1:'Machine',
        tableTitle2:'Recipe',
        tableTitle3:'Reviser',
        tableTitle4:'Date/Time',
        tableTitle5:'Item',
        tableTitle6:'Data',
    },
    //新增带束位置信息
    BeamPositionInfo:{
        selectPlacehoder: 'Group',
        error1: 'Please choose the machine',
        error2: 'Please choose the date',
        error3: 'Please choose the group',
        error4: 'No more than 24 hours'
    },
    //VPN申请
    VpnApply:{
        title: 'VPN Apply',
        searchCompany: 'Company name',
        enterCompany: 'Enter company keywords',
        searchBox: 'Box Name',
        enterBox: 'Enter box keywords',
        Clean: 'clean',
        search: 'search',
        company: 'Company',
        box: 'Box',
        boxIp: 'boxIP',
        createTime: 'Create Time',
        status: 'Status',
        reviewer: 'Reviewer',
        operation: 'Operate'
    },
    //VPN审核
    VpnReview:{
        title: 'VPN Review',
        searchUser: 'applicant',
        enterUser: 'Enter Keyword',
        search: 'search',
        company: 'company',
        box: 'box',
        boxIp: 'boxIP',
        applyUser: 'applicant',
        applyTime: 'Apply Time',
        operation: 'operation'
    },
    //VPN添加
    VpnManage:{
        title: 'VPN Manage',
        searchCompany: 'CompanyName',
        enterCompany: 'Enter factory keywords',
        searchBox: 'Box Name',
        enterBox: 'Enter box keywords',
        Clean: 'clean',
        search: 'search',
        company: 'company',
        boxName: 'boxName',
        boxType: 'boxType',
        boxIP: 'boxIP',
        createUser: 'createUser',
        createTime: 'createTime',
        credentials: 'credentials',
        operation: 'operation',
        operationDelete: 'delete',

        certificateLimitDate: 'EffectiveDays',
        notifyLimitDate: 'ReminderDays',
        certificateLimitNum: 'CertificateLimit',
        enterCertificateLimitNum: 'Enter CertificateLimit',
        enterCertificateLimitDate: 'Enter EffectiveDays',
        enterNotifyLimitDate: 'Enter ReminderDays',

        boxMsg: 'BoxInformation',
        belongMachine: 'AffiliatedEquipment',
        add: 'Add',
        cancel: 'Cancel',
        reset: 'Reset',
        certificateMsg: 'CertificateInformation',
        applicant: 'Applicant',
        applyTime: 'ApplyTime',
        applyIp: 'IpAddress',
        reviewer: 'Reviewer',
        reviewTime: 'ReviewTime',
        loseTime: 'ExpireTime',
        enterBoxName: 'EnterBoxName',
        chooseMachine: 'ChooseMachine',
        enterBoxType: 'EnterBoxType'
    },
    ...enLocale
}